import type { PropsWithChildren } from 'react'
import { FilterHeader, type FilterHeaderProps } from 'shared/components/filter-header'
import { HeaderCounter } from 'shared/components/header-counter'
import { CountInterface } from 'shared/types/pagination-interface'
import { twMerge } from 'tailwind-merge'

type WithClass = { className?: string }

function PageRoot({ children, className }: PropsWithChildren<WithClass>) {
  return <div className={twMerge('flex flex-col gap-4', className)}>{children}</div>
}

function HeaderRoot(
  props: PropsWithChildren<
    WithClass &
      Pick<FilterHeaderProps, 'actions' | 'filters'> & {
        counter?: CountInterface | false
      }
  >,
) {
  const { children, actions, className, counter, filters } = props
  return (
    <FilterHeader
      title={children}
      counter={
        'counter' in props && counter !== false ? <HeaderCounter count={counter?.count} /> : null
      }
      filters={filters}
      actions={actions}
      className={className}
    />
  )
}

function Banner({ children, className }: PropsWithChildren<WithClass>) {
  return <div className={twMerge('flex flex-col', className)}>{children}</div>
}

function Toolbar({ children, className }: PropsWithChildren<WithClass>) {
  return <div className={twMerge('flex flex-wrap items-center gap-2', className)}>{children}</div>
}

function Body({ children, className }: PropsWithChildren<WithClass>) {
  return <div className={twMerge(className)}>{children}</div>
}

function Sidebar({ children, className }: PropsWithChildren<WithClass>) {
  return (
    <aside
      className={twMerge('desktop:sticky desktop:top-5 desktop:w-95 w-full shrink-0', className)}
    >
      {children}
    </aside>
  )
}

export const Page = Object.assign(PageRoot, {
  Header: HeaderRoot,
  Banner,
  Toolbar,
  Body,
  Sidebar,
})
